var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerraNostraPrincipal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1533,
    height: 343,
    viewBox: "0 0 1533 343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-carlos);\n      }\n\n      .cls-2, .cls-3 {\n        fill: #813b30;\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-carlos"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1533,
    height: 343
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carlos",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 1533,
    height: 343
  }), /*#__PURE__*/React.createElement("g", {
    id: "PTN_Marca-02",
    transform: "translate(3.876 -326.89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    className: "cls-2",
    width: 10.295,
    height: 335.4,
    transform: "translate(1513.952 330.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    className: "cls-2",
    width: 1192.978,
    height: 11.55,
    transform: "translate(331.262 330.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    className: "cls-2",
    width: 1189.11,
    height: 11.422,
    transform: "translate(335.13 526.426)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    className: "cls-2",
    width: 1192.491,
    height: 10.543,
    transform: "translate(331.749 655.086)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    className: "cls-2",
    width: 10.295,
    height: 335.4,
    transform: "translate(339.383 330.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    className: "cls-3",
    d: "M10.73,330.15H345.81V665.206H10.73ZM212.417,581.5s53.427-63.779,133.336-26.818V522.269S244.455,500.3,206.087,581.5Zm-10.215,0s26.818-81,143.552-78.231V470.7S230.914,475,198.269,581.5Zm-6.259,0s6.067-98.142,149.811-128.309V429.715H305.731S207.669,457.26,193.425,581.5h2.526Zm-4.756,0s-2.054-86.967,80.269-151.785H227.924s-35.6,26.538-41.2,151.785h4.452Zm-8.369,0c9.5-127.485,24.516-151.785,24.516-151.785H151.388s15.043,24.3,24.539,151.785h6.89Zm-32.413,0c-38.368-81.2-139.675-59.23-139.675-59.23v32.413C85.236,518.544,144.09,581.5,144.09,581.5Zm8.937,0C123.588,474.589,10.73,470.7,10.73,470.7v32.565C127.5,500.5,155.425,581.5,155.425,581.5h3.909Zm5.963,0C151.085,457.268,50.793,429.715,50.793,429.715H10.73v23.476C154.514,483.358,162.787,581.5,162.787,581.5H165.3Zm5.587,0c-5.587-125.247-42.317-151.785-42.317-151.785H85.036c82.323,64.81,82.515,151.785,82.515,151.785H170.9Z",
    transform: "translate(-2.153)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    className: "cls-2",
    width: 10.295,
    height: 335.4,
    transform: "translate(0 330.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    className: "cls-3",
    d: "M657.924,672.977a13.161,13.161,0,1,1,9.272-22.461l5.715-5.715a21.464,21.464,0,0,0-14.987-6.171,21.186,21.186,0,1,0,21.19,21.2h-21.19v7.546h10.767a13.071,13.071,0,0,1-10.767,5.6",
    transform: "translate(-131.338 -61.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    className: "cls-3",
    d: "M756.978,680.063h8.681l-16.1-41.973-16.17,41.973h8.665l1.231-3.413h12.422l1.263,3.413Zm-7.418-19.752,3.981,10.551h-8.049Z",
    transform: "translate(-151.253 -61.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    className: "cls-3",
    d: "M848.707,654.777A15.111,15.111,0,0,0,833.6,639.67H823.32v40.7h8.089V669.861l9.208,10.511h10.775l-10.775-12.286a15.113,15.113,0,0,0,8.089-13.309m-8.089,0a7.04,7.04,0,0,1-7.018,7h-2.19V647.743h2.19a7.046,7.046,0,0,1,7.018,7.034",
    transform: "translate(-169.787 -62.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    className: "cls-3",
    d: "M939.654,660.037a20.41,20.41,0,0,0-20.391-20.367H909v40.71h10.263a20.4,20.4,0,0,0,20.391-20.343m-8.089,0a12.247,12.247,0,0,1-12.3,12.262h-2.19V647.743h2.19a12.259,12.259,0,0,1,12.3,12.294",
    transform: "translate(-187.465 -62.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    className: "cls-3",
    d: "M1022.184,680.372V672.3h-13.572v-8.4h13.572v-8.025h-13.572v-8.121h13.572V639.67H1000.49v40.7Z",
    transform: "translate(-206.3 -62.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    className: "cls-3",
    d: "M1107.273,681.216V639.387h-8.1v19.024L1081.91,638.26v41.829H1090V661.121Z",
    transform: "translate(-223.104 -61.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    className: "cls-3",
    d: "M586.835,435.624V423.33h-65.9v12.294h26.706V547.01h12.286V435.624Z",
    transform: "translate(-107.502 -18.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    className: "cls-3",
    d: "M683.443,547V534.751H642.078V518.46h41.365V506.167H642.078V435.626h41.365V423.34H629.8V547Z",
    transform: "translate(-129.939 -18.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    className: "cls-3",
    d: "M794.808,466.136a42.814,42.814,0,0,0-42.788-42.8H733.06V547.013h12.27V508.4l33.94,38.608H795.7l-34.139-39.2a42.487,42.487,0,0,0,33.252-41.677m-12.294,0a30.58,30.58,0,0,1-30.495,30.51h-6.69V435.626h6.69a30.585,30.585,0,0,1,30.495,30.511",
    transform: "translate(-151.269 -18.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    className: "cls-3",
    d: "M909.31,466.136a42.791,42.791,0,0,0-42.8-42.8H847.57V547.013h12.262V508.4l33.947,38.608h16.45l-34.139-39.2a42.492,42.492,0,0,0,33.22-41.677m-12.294,0a30.566,30.566,0,0,1-30.5,30.51h-6.682V435.626h6.682a30.571,30.571,0,0,1,30.5,30.511",
    transform: "translate(-174.898 -18.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    className: "cls-3",
    d: "M1024.627,546.063H1037.8L988.865,418.61,939.93,546.063h13.189L959.8,528.19h58.135Zm-35.762-94.457,25.083,66.464h-50.19Z",
    transform: "translate(-194.088 -17.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    className: "cls-3",
    d: "M1388.7,484.63A64.454,64.454,0,1,0,1324.24,548.9,64.478,64.478,0,0,0,1388.7,484.63m-116.087,0a51.641,51.641,0,1,1,51.629,51.629,51.788,51.788,0,0,1-51.629-51.629",
    transform: "translate(-260.299 -18.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    className: "cls-3",
    d: "M1460.456,456.643c0-12.453,5.251-21.31,11.942-28.336l-10.319-8.137c-10.287,11.007-13.868,22.917-13.868,36.466,0,25.275,14.42,32.141,14.42,55.785,0,12.478-5.228,21.3-11.91,28.36l10.3,8.1c10.279-11,13.893-22.909,13.893-36.465,0-25.275-14.46-32.141-14.46-55.785",
    transform: "translate(-298.646 -18.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    className: "cls-3",
    d: "M1567.837,435.624V423.33h-65.9v12.294h26.73V547.01h12.262V435.624Z",
    transform: "translate(-309.949 -18.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    className: "cls-3",
    d: "M1672.54,466.136a42.767,42.767,0,0,0-42.78-42.8H1610.8V547.013h12.27V508.4l33.972,38.608h16.41l-34.123-39.2a42.452,42.452,0,0,0,33.212-41.677m-12.278,0a30.566,30.566,0,0,1-30.5,30.51h-6.682V435.626h6.682a30.571,30.571,0,0,1,30.5,30.511",
    transform: "translate(-333.705 -18.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    className: "cls-3",
    d: "M1787.869,546.063h13.189L1752.131,418.61,1703.22,546.063h13.141l6.7-17.873h58.119l6.7,17.873Zm-35.738-94.457,25.1,66.464h-50.206l25.1-66.464Z",
    transform: "translate(-352.251 -17.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    className: "cls-2",
    d: "M1210.018,488.23l-51.893-39.911v97.406H1146V424.18l51.893,40.246",
    transform: "translate(-236.487 -18.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    className: "cls-2",
    d: "M1223.046,424.17V545.724H1210.92V424.17",
    transform: "translate(-249.649 -18.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    className: "cls-3",
    d: "M1259.62,665.754v-7.865h-13.365v-8.025h13.365V641.95h-21.31v39.982h7.945V665.754Z",
    transform: "translate(-255.337 -62.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    className: "cls-3",
    d: "M1336.381,670.206V641.95h-7.889v28.256a4.689,4.689,0,0,1-4.668,4.668,4.633,4.633,0,0,1-4.6-4.668V641.95h-7.937v28.256a12.545,12.545,0,0,0,25.091,0",
    transform: "translate(-270.403 -62.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    className: "cls-3",
    d: "M1416.131,656.762a14.855,14.855,0,0,0-14.852-14.812h-10.12v39.982h7.969V671.6l9.032,10.335h10.559l-10.559-12.11a14.811,14.811,0,0,0,7.969-13.069m-7.969,0a6.907,6.907,0,0,1-6.882,6.9h-2.15v-13.8h2.15a6.92,6.92,0,0,1,6.882,6.89",
    transform: "translate(-286.886 -62.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    className: "cls-3",
    d: "M1493.211,682.783v-41.11h-7.937v18.672L1468.36,640.57v41.086h7.929V663.031Z",
    transform: "translate(-302.791 -62.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    className: "cls-3",
    d: "M1564.328,681.624h8.505L1557,640.41l-15.859,41.214h8.513l1.247-3.357h12.19Zm-7.33-19.4,3.933,10.327h-7.874L1557,662.224Z",
    transform: "translate(-319.727 -62.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    className: "cls-3",
    d: "M1642.47,670.271c0-11.942-15.283-13.261-15.283-18.464,0-1.527,1.631-2.9,3.573-2.9a3.5,3.5,0,0,1,3.485,2.478l7.178-3.677a11.669,11.669,0,0,0-10.671-6.786c-6.4,0-11.566,4.876-11.566,10.887,0,11.215,15.227,11.838,15.227,18.464a4.613,4.613,0,0,1-4.852,4.292,4.869,4.869,0,0,1-4.764-3.413l-6.906,4.324a13.033,13.033,0,0,0,11.67,7.058c7.138,0,12.909-5.475,12.909-12.262",
    transform: "translate(-335.128 -62.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    className: "cls-2",
    d: "M1162.58,663.807a8.925,8.925,0,1,1,8.912,8.881,8.916,8.916,0,0,1-8.912-8.881",
    transform: "translate(-239.707 -65.161)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraNostraPrincipal);
export default __webpack_public_path__ + "static/media/TerraNostraPrincipal.a8ce89883ba3652ff65903df679f2c78.svg";
export { ForwardRef as ReactComponent };